import { useState, useEffect, useRef } from 'react';
import { Link, Redirect, useLocation } from 'react-router-dom';
import Select from 'react-select';
import Hosts from '../../../Hosts';
import { object_type, api_crud_base, api_crud_route, data_interface, endpoints } from './Config';
import { getTokenInfo } from '../../../UseToken';
import UseSidebar from '../../../UseSidebar';
import Loader from '../../Loader/Loader';
import Swal from 'sweetalert2';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
import { Modal, Button, Form } from 'react-bootstrap';
import SortableTree from 'react-sortable-tree';

import {
	reqGET,
	reqPOST,
	reqDELETE,
	reqPUT,
	reqFILE,
	obter_cidades_por_distrito,
	obter_freguesias_por_cidade,
	obter_paises_em_pt,
	obter_distritos_pt,
	pattern_vat,
	pattern_email,
	passwordHash,
	translate,
	handle_compressed_image_upload,
	set_language
} from '../../../Utils';

import { language } from './Language';
import { color } from '../../WEBContent/Color';

export default function Regist(props) {
	const [, set_dados] = useState(null);
	const dados = useRef(data_interface);
	const permissions = useRef(null);
	const { pathname } = useLocation();

	const entity_category = useRef(null);
	const entity_type = useRef(null);
	const entity_type_filter = useRef(null);
	const entity_nature = useRef(null);
	const entity_nature_filter = useRef(null);
	const entity_quality = useRef(null);
	const entity_quality_filter = useRef(null);
	const entity_legal_form = useRef(null);
	const entity_legal_form_filter = useRef(null);
	const entity_relation = useRef(null);
	const entity_relation_raw = useRef(null);
	const entity_relation_filter = useRef(null);

	const app_profiles = useRef(null);
	const app_profiles_filter = useRef(null);
	const entity_profiles = useRef(null);
	const entity_profiles_filter = useRef(null);
	const entity_function = useRef(null);
	const entity_function_filter = useRef(null);

	const [lang, set_lang] = useState('pt');
	const [lang_id, set_lang_id] = useState('1');

	const [isloading, setLoading] = useState(true);
	const [isRedirect, setRedirect] = useState(false);
	const [refresh, setRefresh] = useState(0);

	const [show_delete_button, set_show_delete_button] = useState(false);

	const [new_password, set_new_password] = useState('')
	const [confirm_password, set_confirm_password] = useState('')

	const [is_edit, set_is_edit] = useState(false)

	const [, set_show_district_city_village] = useState('');
	const [, set_disabled] = useState(false)

	const [countries, set_countries] = useState([])
	const [districts, set_districts] = useState([])
	const [cities, set_cities] = useState([])
	const [villages, set_villages] = useState([])

	/////////////////////////////////////////////////////////////////////////
	const [, setSelectedUserTypeId] = useState('');
	const [userTypes, setUserTypes] = useState([]);
	const [userTypesEntities, setUserTypesEntities] = useState([]);
	const [modalDetalhes, setModalDetalhes] = useState(false);

	//Responsaveis///////////////////////////////////////////////////////////
	const [modalResponsavel, setModalResponsavel] = useState(false);
	const [responsavelInputNome, setResponsavelInputNome] = useState('');
	const [responsavelInputEmail, setResponsavelInputEmail] = useState('');
	const [responsavelInputTel, setResponsavelInputTel] = useState('');
	const [, setAllResponsaveis] = useState([]);
	const [, setTeamLeader] = useState([]);

	//Departamento
	const [modalDepartamento, setModalDepartamento] = useState(false);
	const [departamentos, setDepartamentos] = useState([]);
	const [selectedDepartamentoId, setSelectedDepartamentoId] = useState('');
	const [, setDepartamentoSelecionado] = useState([]);
	const [departamentoInput, setDepartamentoInput] = useState('');
	const [selectedDepartamento, setSelectedDepartamento] = useState(null);
	const [selectedSoftware, setSelectedSoftware] = useState({});

	//Entidade Interna
	const [, setColaborador] = useState('');
	const [selectedColaborador, setSelectedColaborador] = useState('');
	const [tag, setTag] = useState('');

	//Entidade Externa
	const [, setTipoCliente] = useState('');
	const [selectedTipoCliente, setSelectedTipoCliente] = useState('');

	//relacao	
	const [, setSelectedTipoRelacao] = useState('');

	//foto	
	const [files_image, set_files_image] = useState([]);
	const [image_base64, set_image_base64] = useState([]);
	const [photo_base64, set_photo_base64] = useState('');
	const [img_loader, set_img_loader] = useState([])

	//pdf
	const [files_doc, set_files_doc] = useState([]);
	const [files_doc_name, set_files_doc_name] = useState([]);
	const [treeDataCV, setTreeDataCV] = useState([])

	//////////////////////////////////////////////////////////////////////////
	const [showNat, setShowNat] = useState(false);
	const [showOverView, setShowOverview] = useState(false);
	const [showFunctions, setShowFunctions] = useState(true);
	const [showFiscalData, setShowFiscalData] = useState(false);
	const [showContract, setShowContract] = useState(false);
	const [showSettings, setShowSettings] = useState(false);

	const entidadeOptions = [
		{ id: "1", label: "Interna" },
		{ id: "2", label: "Externa" },
	];

	const tipoEntidadeOptions = [
		{ id: "1", label: "Pessoal" },
		{ id: "2", label: "Empresarial" },
	];

	const tipoRelacaoOptions = [
		{ id: "1", label: "Agente" },
		{ id: "2", label: "Cliente" },
		{ id: "3", label: "Colaborador" },
		{ id: "4", label: "Distribuidor" },
		{ id: "5", label: "Fornecedor" },
		{ id: "6", label: "Investidor" },
		{ id: "7", label: "Parceiro" },
		{ id: "8", label: "Sócio" },
		{ id: "9", label: "Outro" },
	];

	const tableStyle = {
		width: '100%',
		borderCollapse: 'collapse',
		fontSize: '14px',
		color: color.cor1.hexa,
		textAlign: 'left',
		boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
		borderRadius: '8px',
		overflow: 'hidden',
		backgroundColor: color.cor3.hexa,
	};

	const headerCellStyle = {
		padding: '12px 15px',
		textAlign: 'center',
		color: color.cor3.hexa,
		fontWeight: '600',
		borderBottom: '2px solid #ddd',
		backgroundColor: color.cor2.rgb,
		textTransform: 'uppercase',
	};

	const departamentoHeaderCellStyle = {
		...headerCellStyle,
		textAlign: 'left',
	};

	const cellStyle = {
		borderBottom: `1px solid rgb(${color.cor3.rgb})`,
		textAlign: 'center',
		verticalAlign: 'middle',
		padding: '12px 15px',
		color: color.corCinza.hexa,
		lineHeight: '1.6',
		backgroundColor: '#fafafa',
	};

	const rowStyle = {
		fontSize: '14px',
		backgroundColor: color.cor3.hexa,
		transition: 'background-color 0.3s ease',
	};

	const actionCellStyle = {
		padding: '10px',
		border: '1px solid #ddd',
		textAlign: 'center',
		verticalAlign: 'middle',
		width: '50px',
		backgroundColor: color.cor1.hexa,
		transition: 'background-color 0.3s',
	};

	const departmentCellStyle = {
		backgroundColor: color.cor1.hexa,
		...cellStyle,
		textAlign: 'left',
		fontWeight: '500',
	};

	const lastRowStyle = {
		borderBottom: '0.5px solid grey',
	};

	const onChangeHandlerFilesImage = async (e) => {
		const { files, dataset } = e.target;
		const { order, langid, lang } = dataset

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);
		let files_img_aux = image_base64

		let k = 0
		// filesArray.forEach(async (v, k) => {
		for await (let v of filesArray) {
			if ((v.type.includes('image/')) && (v.size < 10485760)) {

				console.log('1')
				await handle_compressed_image_upload(v, (valor) => storedFiles.push(valor))
				//storedFiles.push(v);

				console.log('2')
				await convertBase64(v)
					.then((base64) => {
						// console.log('base64', base64)

						if (files_img_aux[order] === undefined)
							files_img_aux[order] = []
						if (files_img_aux[order][langid] === undefined)
							files_img_aux[order][langid] = []

						files_img_aux[order][langid].push({ id: '1', langid: langid, name: v.name.split('.')[0] + '.webp', link: base64 })
						set_image_base64(files_img_aux)
						set_photo_base64(base64)
						setRefresh(refresh + Math.random())
					})


				console.log('3')

				if (filesArray.length === (k + 1)) {
					//set_dados(dados.current,)
					//setRefresh(refresh + 1)
					setRefresh(refresh + parseInt(v.size) + k)
				}


				console.log('4')

			}
			else {
				Swal.fire(language[lang].upload_image_error + v.name, '', 'info')
			}

			k++
		}
		// });

		console.log('storedFiles', storedFiles)


		let files_aux = files_image
		files_aux.push({ files: storedFiles, order: order, lang: lang, langid: langid })
		set_files_image(files_aux)

	}

	const convertBase64 = async (file) => {
		return new Promise((resolve, reject) => {
			const fileReader = new FileReader();
			fileReader.readAsDataURL(file);

			fileReader.onload = () => {
				resolve(fileReader.result);
			};

			fileReader.onerror = (error) => {
				reject(error);
			};
		});
	};

	const handleFileRemove = () => {

		set_dados(dados.current.info.foto = [])

	};

	const uploadFilesImage = async (files, order, type, langid, lang) => {

		let aux = []
		files.forEach(async (element) => {
			if (element.type.includes('image/')) {
				aux.push(element)

				let y = img_loader
				y.push('img')
				set_img_loader(y)

				await uploadFile(element, order, type, langid, lang)
					.then(() => {
						//console.log('success')
					})
			}
			else {
				Swal.fire('Formato do ficheiro incorrecto!', '', 'info')
			}
		})
	}

	const onChangeHandlerFilesPDF = (e) => {
		const { files, dataset } = e.target;
		const { order, langid, lang } = dataset

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);

		filesArray.forEach(async (v) => {
			if ((v.type.includes('/pdf')) && (v.size < 10485760)) {
				storedFiles.push(v);

				let aux2 = files_doc_name
				if (aux2[langid] === undefined)
					aux2[langid] = []
				aux2[langid].push({ name: v.name, size: v.size })
				set_files_doc_name(aux2)

				let aux_doc_cv = treeDataCV
				if (treeDataCV[order] === undefined)
					treeDataCV[order] = []
				if (treeDataCV[order][langid] === undefined)
					treeDataCV[order][langid] = []
				let i = treeDataCV[order][langid].length
				// aux_doc_cv[order][langid].push({ id: ++i, id_doc: '', title: v.name, link: v.link, visible: true })
				aux_doc_cv[order][langid][0] = { id: ++i, id_doc: '', title: v.name, link: v.link, visible: true }
				setTreeDataCV(aux_doc_cv)

				set_dados(dados.current,)
				setRefresh(refresh + 1)
			}
			else {
				alert(language[lang].upload_file_error + v.name);
			}
		});

		let files_aux = files_doc
		files_aux.push({ files: storedFiles, order: order, lang: lang, langid: langid })
		set_files_doc(files_aux)
	}

	const uploadFilesDoc = async (files, order, type, langid, lang) => {
		let aux = []
		files.forEach((element) => {
			if (element.type === "application/pdf") {
				aux.push(element)

				uploadFile(element, order, type, langid, lang)
					.then(() => {
						//console.log('success')
					})
			}
			else {
				Swal.fire('Formato do ficheiro incorrecto!', '', 'info')
			}
		})
	}

	const uploadFile = async (file, order, type, langid, lang) => {
		const formData = new FormData()
		formData.append('files', file)
		formData.append('id', dados.current.id)
		formData.append('file_name', file.name)
		formData.append('type', 'content')
		formData.append('companycode', dados.current.info.companycode)
		formData.append('uniqid', dados.current.info.uniqid)
		formData.append('folder', Hosts.APP_REPO_FOLDER + 'upload/content/');

		console.log('api_crud_base', api_crud_base)
		console.log('formData', formData)

		return await reqFILE(`${api_crud_base}/multimedia/file`, formData)
			.then((res) => {
				var today_file = new Date()

				let i = Date.now()

				let x = {
					id: i,
					info: {
						companycode: getTokenInfo().companycode,
						type: res.data.mimetype,
						link: res.data.path + '/' + res.data.name,
						size: res.data.size,
						date: today_file
					},
					content: {
						name: file.name,
						description: '',
						lang: []
					}
				}

				if (type === 'photo') {
					dados.current.info.foto = [
						{
							name: file.name,
							type: file.type,
							size: file.size,
							path: res.data.path,
							source_name: res.data.name,
							link: res.data.path + '' + res.data.name,
						},
					];
				}
				else if (type === 'cv') {
					dados.current.info.cv = [
						{
							name: file.name,
							type: file.type,
							size: file.size,
							path: res.data.path,
							source_name: res.data.name,
							link: res.data.path + '' + res.data.name,
						},
					];
				}

				reqPUT(api_crud_route, dados.current)
					.then(() => {
						//props.history.push(endpoints.list) 
					})
					.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))

				reqPOST(`${api_crud_base}/multimedia`, x)
					.then(() => {

						let y2 = img_loader
						y2.pop()
						set_img_loader(y2)
						setRefresh(i)

					})
					.catch(() => Swal.fire('Problema ao inserir Registo!', '', 'info'))

				return true

			})
			.catch(erro => console.log('Erro POST File: ' + erro))
	}

	const handleEntidade = (event) => {
		const value = event.target.value;
		const selectedOption = entidadeOptions.find((option) => option.id === value);

		if (!Array.isArray(dados.current.info.entity)) {
			dados.current.info.entity = [];
		}

		dados.current.info.entity = [{ id: selectedOption.id, label: selectedOption.label }];
		setColaborador(selectedOption.label);
		setSelectedColaborador(selectedOption.id);
	};

	const handleTipoEntidade = (event) => {
		const value = event.target.value;
		const selectedOption = tipoEntidadeOptions.find((option) => option.id === value);

		if (!Array.isArray(dados.current.info.type)) {
			dados.current.info.type = [];
		}
		dados.current.info.type = [{ id: selectedOption.id, label: selectedOption.label }];
		dados.current.info.profile = { name: selectedOption.label };
		setTipoCliente(selectedOption.label);
		setSelectedTipoCliente(selectedOption.id);
	};

	const handleRelacaoChange = (event) => {
		const { value, checked } = event.target;

		if (!dados.current.info.relacao) {
			dados.current.info.relacao = [];
		}

		const selectedOption = tipoRelacaoOptions.find(option => option.id === value);

		if (checked && selectedOption) {
			if (!dados.current.info.relacao.some(item => item.id === value)) {
				dados.current.info.relacao.push({ id: selectedOption.id, label: selectedOption.label });
			}
			setSelectedTipoRelacao(prev => [...prev, selectedOption.label]);
		} else {
			dados.current.info.relacao = dados.current.info.relacao.filter(item => item.id !== value);
			setSelectedTipoRelacao(prev => prev.filter(label => label !== selectedOption.label));
		}
	};

	const change_lang = (l) => {
		set_language(l)
		set_lang(l)

		//console.log('language', localStorage.getItem('lang'))
		//console.log('localstorage', localStorage)
	}

	const handleUserTypeChange = (e) => {
		const selectedValue = e.target.value;
		setSelectedUserTypeId(selectedValue);

		console.log('#####################')
		console.log('selectedValue', selectedValue)


		let profile_filter = app_profiles.current.filter(el => parseInt(el.id) === parseInt(selectedValue))
		console.log('profile_filter', profile_filter)

		if (Array.isArray(profile_filter) && profile_filter.length > 0) {
			let aux = {
				id: selectedValue,
				name: profile_filter[0].name
			}

			set_dados(dados.current.profile = aux)

			console.log('dados.current.profile', dados.current.profile)

		}
	};

	const handleUserTypeEntityFunctionsChange = (e) => {
		const selectedValue = e.target.value;

		if (!Array.isArray(dados.current.info.attributes.entity_function)) {
			dados.current.info.attributes.entity_function = []
		}
		let aux = dados.current.info.attributes.entity_function.filter(el => parseInt(el.id) !== parseInt(selectedValue))
		aux.push(selectedValue)

		set_dados(dados.current.info.attributes.entity_function = aux);

		console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>')
		console.log('Dados Current:', (dados.current.info))

	};

	const handleUserTypeEntityRemove = (id) => {

		Swal.fire({
			title: language[lang].remove_title,
			text: language[lang].remove_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: color.corPrimaria.rgb,
			cancelButtonColor: color.corVermelha.rgb,
			confirmButtonText: language[lang].remove_confirm,
			cancelButtonText: language[lang].remove_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {

					if (Array.isArray(dados.current.info.attributes.entity_function) && dados.current.info.attributes.entity_function.length > 0) {
						let aux = dados.current.info.attributes.entity_function.filter(el => parseInt(el) !== parseInt(id))
						set_dados(dados.current.info.attributes.entity_function = aux);
					}
					else {
						set_dados(dados.current.info.attributes.entity_function = []);
					}

				}
			})

	}
	/// DEPARTAMENTOS ///////////////////////////////////////////////////

	const handleCloseModal = () => {
		setModalDetalhes(false);
		setDepartamentoSelecionado(null);
	};

	const handleSaveChanges = () => {
		if (!selectedDepartamento) {
			console.error("No department selected to update.");
			return;
		}

		const updatedDepartamentos = [...dados.current.contacts[0].departamentos];
		const departamentoIndex = updatedDepartamentos.findIndex(dep => dep.id === selectedDepartamento.id);

		if (departamentoIndex !== -1) {
			updatedDepartamentos[departamentoIndex] = { ...selectedDepartamento };

			dados.current.contacts[0].departamentos = updatedDepartamentos;

			set_dados(prevDados => ({
				...prevDados,
				contacts: [{
					...prevDados.contacts[0],
					departamentos: updatedDepartamentos
				}]
			}));

		} else {
			console.error("Department not found for update:", selectedDepartamento);
		}
		setModalDetalhes(false);
	};

	const handleAddDepartamento = () => {
		// Ensure departamentos is initialized as an array
		if (!dados.current.contacts[0].departamentos) {
			dados.current.contacts[0].departamentos = [];
		}

		// Calculate new ID for departamento
		const departamentos = dados.current.contacts[0].departamentos;
		const departamentoExists = departamentos.some(dep => dep.name.toLowerCase() === departamentoInput.toLowerCase());

		if (departamentoExists) {
			alert("O departamento já existe.");
			return;
		}

		const newId = departamentos.length > 0 ? departamentos[departamentos.length - 1].id + 1 : 1;

		// Create the new departamento object
		const newDepartamento = { id: newId, name: departamentoInput, responsaveis: [] };

		// Push the new departamento to both dados.current and data_interface
		dados.current.contacts[0].departamentos.push(newDepartamento);

		// Clear the input and close the modal
		setDepartamentoInput('');
		setModalDepartamento(false);
	};

	////////////////////////////////////////////////////////
	const handleAddResponsavel = () => {
		// Verifica se há um departamento selecionado
		if (!selectedDepartamentoId) {
			alert("Selecione um departamento antes de adicionar um responsável.");
			return;
		}

		// Garante que contacts é um array válido
		const contatos = dados.current.contacts || [];
		if (contatos.length === 0) {
			alert("Nenhum contato disponível.");
			return;
		}

		// Pega o array de departamentos do primeiro contato
		const departamentos = contatos[0]?.departamentos || [];

		// Encontra o departamento selecionado
		const departamentoIndex = departamentos.findIndex(dep => dep.id === parseInt(selectedDepartamentoId));
		if (departamentoIndex === -1) {
			alert("Departamento não encontrado.");
			return;
		}

		// Calcula um novo ID para o responsável
		const responsaveis = departamentos[departamentoIndex]?.responsaveis || [];
		const newResponsavelId = responsaveis.length > 0 ? responsaveis[responsaveis.length - 1].id + 1 : 1;

		// Cria o novo responsável
		const newResponsavel = {
			id: newResponsavelId,
			nome: responsavelInputNome,
			email: responsavelInputEmail,
			telefone: responsavelInputTel
		};

		// Adiciona o novo responsável ao departamento
		departamentos[departamentoIndex].responsaveis.push(newResponsavel);

		// Atualiza a estrutura de dados
		set_dados(prevDados => ({
			...prevDados,
			contacts: prevDados.contacts ? [{
				...prevDados.contacts[0],
				departamentos: [...departamentos]
			}] : []
		}));

		// Limpa os inputs e fecha o modal
		setResponsavelInputNome('');
		setResponsavelInputEmail('');
		setResponsavelInputTel('');
		setModalResponsavel(false);

	};

	const handleRemoveDepartamento = (departamentoId) => {
		// Ensure departamentos is initialized as an array
		if (!dados.current.contacts[0].departamentos) {
			dados.current.contacts[0].departamentos = [];
		}

		// Filter out the departamento with the specified ID
		const updatedDepartamentos = dados.current.contacts[0].departamentos.filter(
			(departamento) => departamento.id !== departamentoId
		);

		// Update the dados.current and data_interface
		dados.current.contacts[0].departamentos = updatedDepartamentos;

	};

	const mostrarDetalhes = (departamentoId) => {
		setModalDetalhes(true);
		const departamento = dados.current.contacts[0].departamentos.find(depart => depart.id === departamentoId);
		if (departamento) {
			setSelectedDepartamento(departamento);
		}
	};
	/////////////////////////////////////////////////////////////////////////////////////////////////////

	const change_country = e => {

		set_cities([])
		set_villages([])

		set_dados(dados.current.addresses[0].city = '');
		set_dados(dados.current.addresses[0].village = '');
		set_dados(dados.current.addresses[0].region = '');

		if (e.value === "Portugal") {

			set_show_district_city_village('')

			if (districts.length === 0) {
				obter_distritos_pt(set_districts)
			}
		}
		else {
			set_show_district_city_village('d-none')
		}

		set_dados(dados.current.addresses[0].country = e.value);
	}

	const change_district = e => {

		set_cities([])
		set_villages([])

		obter_cidades_por_distrito(e.value, set_cities)

		set_dados(dados.current.addresses[0].city = '');
		set_dados(dados.current.addresses[0].village = '');
		set_dados(dados.current.addresses[0].region = e.value);
	}

	const change_city = e => {
		set_villages([])
		obter_freguesias_por_cidade(e.value, set_villages)
		set_dados(dados.current.addresses[0].village = '');
		set_dados(dados.current.addresses[0].city = e.value);
	}

	const change_village = e => {
		set_dados(dados.current.addresses[0].village = e.value);
		set_dados(dados)
	}

	const change_entity_type = e => {
		set_dados(dados.current.info.entity_type = e.value);
	}

	const fetch_id_info = async (id_serch) => {

		return await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id_serch}`)
			.then(res => {
				if (res.data[0].contacts[0].email === '') {
					res.data[0].contacts[0].email = res.data[0].info.email
				}

				let aux_doc_cv = []
				let i = 0
				console.log('res.data[0].info.cv', res.data[0].info.cv)

				if (!Array.isArray(res.data[0].info.cv)) {
					res.data[0].info.cv = []
				}

				if (res?.data[0]?.info?.cv !== undefined) {
					res.data[0].info.cv.forEach((el, k) => {

						aux_doc_cv = []
						aux_doc_cv[k] = []
						aux_doc_cv[k][1] = []

						aux_doc_cv[k][1].push({ id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible })
					})
					console.log('res.data[0].info.cv', res.data[0].info.cv)
				}
				console.log('aux_doc_cv', aux_doc_cv)
				setTreeDataCV(aux_doc_cv)

				set_dados(dados.current = res.data[0]);
				console.log('Data', res)
				setSelectedSoftware(res.data[0].info.departamento.software || []);
				setTag(res.data[0].info.tag || '')
			})
			.catch(error => console.log(error))
	}

	////////////////////////////////////////////// VAI BUSCAR O TIPO DE UTILIZADOR /////////////////////////////////////

	const checkDepartmento = (id) => {
		if (dados.current && dados.current.info && Array.isArray(dados.current.info.departamento)) {
			return dados.current.info.departamento.some(el => el.id === id);
		}
		return false;
	};

	const escolheDepartamentos = (id) => {
		let updatedSelecionado;

		if (!Array.isArray(dados.current.info.departamento)) {
			dados.current.info.departamento = [];
		}

		if (checkDepartmento(id)) {
			updatedSelecionado = dados.current.info.departamento.filter(dept => dept.id !== id);
		} else {
			const selectedDept = departamentos.find(dept => dept.id === id);
			if (selectedDept) {
				updatedSelecionado = [...dados.current.info.departamento, selectedDept];
			}
		}

		dados.current.info.departamento = updatedSelecionado;
		set_dados(dados.current);
		setDepartamentoSelecionado(updatedSelecionado);
	};

	const checkSoftware = (departmentId, softwareId) => {
		if (selectedSoftware[departmentId]?.includes(softwareId)) {
			return true;
		}

		if (dados.current && dados.current.info && Array.isArray(dados.current.info.departamento)) {
			const department = dados.current.info.departamento.find(dept => dept.id === departmentId);

			if (department && Array.isArray(department.software)) {
				return department.software.includes(softwareId);
			}
		}

		return false;
	};

	const escolheSoftware = (departmentId, softwareId) => {
		setSelectedSoftware(prev => {
			const departmentSoftware = prev[departmentId] || [];
			const updatedDepartmentSoftware = departmentSoftware.includes(softwareId)
				? departmentSoftware.filter(id => id !== softwareId)
				: [...departmentSoftware, softwareId];

			return {
				...prev,
				[departmentId]: updatedDepartmentSoftware
			};
		});
	};

	const removeSoftware = (departamentoId, softwareId) => {
		setDepartamentos(prevDepartamentos =>
			prevDepartamentos.map(departamento =>
				departamento.id === departamentoId
					? {
						...departamento,
						software: departamento.software.filter(software => software.id !== softwareId)  // Remove the software by id
					}
					: departamento
			)
		);
	};

	/*
	
	const checkSoftware = (id) => {
		// Verify if 'dados.current' and 'dados.current.software' exist
		if (dados.current && Array.isArray(dados.current.software)) {
			return dados.current.software.some(el => el.id === id);
		}
		return false; // Return false if there are no software items associated
	};

	// Function to select or deselect a software
	const escolheSoftware = (id) => {
		let updatedSelecionado;

		// Initialize software as an array if it's not already one
		if (!Array.isArray(dados.current.software)) {
			dados.current.software = [];
		}

		if (checkSoftware(id)) {
			// If the software is already selected, remove it
			updatedSelecionado = dados.current.software.filter(soft => soft.id !== id);
		} else {
			// Find the selected software by id and add it
			const selectedSoftware = softwares.find(soft => soft.id === id);
			if (selectedSoftware) {
				updatedSelecionado = [...dados.current.software, selectedSoftware];
			}
		}

		// Update the software in dados and set the selected software state
		dados.current.software = updatedSelecionado;
		set_dados(dados.current);
		setSoftwareSelecionado(updatedSelecionado); // Update the state with the new software list
	};
	*/

	///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

	useEffect(() => {

		if (localStorage.getItem('lang') === undefined || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
			change_lang('pt')
		}
		else {
			set_lang(localStorage.getItem('lang'))
			console.log("estamos a alterar para", lang)
		}

	}, [props])

	useEffect(() => {
		if (!Array.isArray(dados.current.info.relacao)) {
			dados.current.info.relacao = [];
		}
	}, []);

	const clean_data = () => {
		// DEEP COPY OF data_interface 
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)

		//console.log(dados.current)
	}

	const fetch_entity_attributes = async (type) => {

		let res = await reqGET(`${api_crud_base}/entities/attributes/type/${getTokenInfo().companycode}/${type}`)
		let result = []
		if (res.data !== undefined) {
			for await (let el of res.data) {
				let aux = {
					id: el.id,
					name: translate(el.info.name, 'pt'),
					type: el.info.type,
					parent: el.info.parent
				}

				result.push(aux)
			}

			if (type === 'entity_relation') {
				set_dados(entity_relation_raw.current = res.data)
			}
		}

		return result

	}

	const order_array = (array) => {

		return array.sort((a, b) => {
			const nameA = a.name.toUpperCase(); // ignore upper and lowercase
			const nameB = b.name.toUpperCase(); // ignore upper and lowercase
			if (nameA < nameB) {
				return -1;
			}
			if (nameA > nameB) {
				return 1;
			}

			// names must be equal
			return 0;
		});

	}

	useEffect(() => {
		const fetchData = async () => {
			try {
				// Reset data before refetching
				set_dados(entity_profiles.current = []);
				set_dados(app_profiles.current = []);
				set_dados(entity_type.current = []);
				set_dados(entity_nature.current = []);
				set_dados(entity_function.current = []);
				set_dados(entity_relation.current = []);

				const companyCode = getTokenInfo().companycode;
				const profile = getTokenInfo().profile;
				const entityProfiles = getTokenInfo().entity_profile || [];

				// Fetch profiles
				const [resEntities, resProfiles] = await Promise.all([
					reqGET(`${Hosts.SIMCore_API}/entities/profiles/${companyCode}`),
					reqGET(`${Hosts.SIMCore_API}/profiles/${companyCode}`)
				]);

				setUserTypesEntities(resEntities.data);
				setUserTypes(resProfiles.data);
				set_dados(entity_profiles.current = resEntities.data);
				set_dados(app_profiles.current = resProfiles.data);

				// Helper to fetch and transform attributes
				const fetchAndSetEntityAttr = async (key, target) => {
					let res = await fetch_entity_attributes(key);
					if (res.length > 0) {
						res = order_array(res);
						const mapped = res.map(el => ({
							id: el.id,
							label: el.name,
							parent: el.parent
						}));
						set_dados(target.current = mapped);
					}
				};

				// Fetch all entity attributes
				await Promise.all([
					fetchAndSetEntityAttr('entity_category', entity_category),
					fetchAndSetEntityAttr('entity_type', entity_type),
					fetchAndSetEntityAttr('entity_nature', entity_nature),
					fetchAndSetEntityAttr('entity_function', entity_function),
					fetchAndSetEntityAttr('entity_relation', entity_relation),
				]);

				// Ensure attribute structure
				if (!dados.current.info.attributes) {
					dados.current.info.attributes = {};
				}

				// Define entity_category value dynamically ('1' or '2')
				const categoryValue = '1'
				set_dados(dados.current.info.attributes['entity_category'] = categoryValue);

				// Filters based on entity_type
				const entityTypeVal = dados.current.info.attributes.entity_type;
				if (entityTypeVal) {
					set_dados(entity_nature_filter.current = entity_nature.current.filter(el => parseInt(el.parent) === parseInt(entityTypeVal)));
				}

				// Filtered lists based on selected category
				const categoryInt = parseInt(categoryValue);
				set_dados(entity_profiles_filter.current = entity_profiles.current.filter(el => parseInt(el.parent || el.settings?.entity_category) === categoryInt));
				set_dados(entity_type_filter.current = entity_type.current.filter(el => parseInt(el.parent) === categoryInt));
				set_dados(entity_function_filter.current = entity_function.current.filter(el => parseInt(el.parent) === categoryInt));
				set_dados(entity_relation_filter.current = entity_relation.current.filter(el => parseInt(el.parent) === categoryInt));

				// Sidebar permissions
				await UseSidebar().getSidebar(profile).then(async (sidebar) => {
					await get_permissions(pathname, sidebar);
				});

				for await (let el of entityProfiles) {
					await UseSidebar().getSidebarEntity(el.name).then(async (v) => {
						await get_permissions(pathname, v);
					});
				}

				console.log('Dados final:', dados.current);
				console.log('Permissões finais:', permissions.current);
			} catch (error) {
				console.error("Erro ao carregar dados iniciais:", error);
			} finally {
				setLoading(false);
			}
		};

		fetchData();
	}, [pathname]);

	useEffect(() => {
		clean_data();
		obter_paises_em_pt(set_countries);

		if (getTokenInfo().profile === 'Cliente') {

			set_is_edit(true)

			set_show_delete_button('d-none')

			fetch_id_info(getTokenInfo().id).then(() => {

				if (dados.current.addresses[0].country === 'Portugal') {

					obter_distritos_pt(set_districts)

					obter_cidades_por_distrito(dados.current.addresses[0].region, set_cities)

					obter_freguesias_por_cidade(dados.current.addresses[0].city, set_villages)
				}
				else {
					set_show_district_city_village('d-none')
				}
			})
			return

		}

		try {
			let test = props.location.state.operation;

			if (test === 'edit') {

				//console.log('000')

				//console.log('NO EDIT')
				set_is_edit(true)

				set_show_delete_button('')

				fetch_id_info(props.location.state.item['id']).then(() => {

					//console.log(dados.current)
					if (dados.current.addresses[0].country === 'Portugal') {

						obter_distritos_pt(set_districts)

						obter_cidades_por_distrito(dados.current.addresses[0].region, set_cities)

						obter_freguesias_por_cidade(dados.current.addresses[0].city, set_villages)
					}
					else {
						set_show_district_city_village('d-none')

					}
				})
				return
			}
		}
		catch {

			clean_data()


			setRedirect(false);
			return

		}
		// BACK
		//props.history.push(endpoints.list)
		return () => {
			clean_data()
		}

	}, [props])

	const fetch_departamentos = async () => {
		try {
			const res = await reqGET(`${Hosts.SIMCore_API}/intranet/departments/${getTokenInfo().companycode}`);
			const departamentoOptions = res.data.map(departamento => ({
				id: departamento.id,
				name: departamento.info.name,
				software: departamento.info.selectedTypes
			}));
			setDepartamentos(departamentoOptions);
		} catch (error) {
			console.error("Erro ao buscar os departamentos:", error);
		}
	};

	const fetch_colaboradores = async () => {
		try {
			const res = await reqGET(`${Hosts.SIMCore_API}/entities/list/${getTokenInfo().companycode}/Colaborador`);
			const colaboradoresOptions = res.data.map(colaborador => ({
				id: colaborador.id,
				name: colaborador.name,
				departamento: colaborador.departamento?.map(departamento => ({
					id: departamento.id,
					name: departamento.name,
				})) || [],
				email: colaborador.email
			}));
			setAllResponsaveis(colaboradoresOptions);
		} catch (error) {
			console.error("Erro ao buscar os colaboradores:", error);
		}
	};

	const fetch_teamleaders = async () => {
		try {
			const res = await reqGET(`${Hosts.SIMCore_API}/entities/list/${getTokenInfo().companycode}/TeamLeader`);
			const teamLeaderOptions = res.data.map(teamLeader => ({
				id: teamLeader.id,
				name: teamLeader.name,
				departamento: teamLeader.departamento?.map(departamento => ({
					id: departamento.id,
					name: departamento.name,
				})) || [],
				email: teamLeader.email
			}));
			setTeamLeader(teamLeaderOptions);
		} catch (error) {
			console.error("Erro ao buscar os TeamLeaders:", error);
		}
	};
	// Group colaboradores and team leaders by departamento
	const groupColaboradoresByDepartamento = (colaboradores, teamLeaders) => {
		const departamentoMap = new Map();

		const addToDepartamento = (dep, type, person) => {
			if (!departamentoMap.has(dep.id)) {
				departamentoMap.set(dep.id, {
					name: dep.name,
					colaboradores: [],
					teamLeaders: []
				});
			}
			departamentoMap.get(dep.id)[type].push(person);
		};

		colaboradores.forEach(colaborador => {
			if (colaborador.departamento && Array.isArray(colaborador.departamento)) {
				colaborador.departamento.forEach(dep => {
					addToDepartamento(dep, "colaboradores", {
						id: colaborador.id,
						name: colaborador.name,
						email: colaborador.email
					});
				});
			} else {
				console.warn(`Colaborador ${colaborador.name} has no valid departamento data.`);
			}
		});

		teamLeaders.forEach(teamLeader => {
			if (teamLeader.departamento && Array.isArray(teamLeader.departamento)) {
				teamLeader.departamento.forEach(dep => {
					addToDepartamento(dep, "teamLeaders", {
						id: teamLeader.id,
						name: teamLeader.name,
						email: teamLeader.email
					});
				});
			} else {
				console.warn(`Team leader ${teamLeader.name} has no valid departamento data.`);
			}
		});

		const result = Array.from(departamentoMap.entries()).reduce((acc, [id, data]) => {
			acc[id] = data;
			return acc;
		}, {});

		return result;
	};

	// Fetch both departamentos and colaboradores and process the data
	const fetchAndDisplayData = async () => {
		await fetch_departamentos();
		await fetch_colaboradores();
		await fetch_teamleaders();
	};

	useEffect(() => {
		fetchAndDisplayData();
	}, []);

	useEffect(() => {
		if (dados.current.info.departamento) {
			const initialSelections = {};
			dados.current.info.departamento.forEach(department => {
				initialSelections[department.id] = department.software
					? department.software.map(software => software.id)
					: [];
			});
			setSelectedSoftware(initialSelections);
		}
	}, [dados.current.info.departamento]);


	function atualizarNotificacaoDiaria() {
		const dataHoje = new Date().toISOString().split('T')[0];

		if (dados.current.info.entity?.some(option => option.label === 'Interna') || selectedColaborador === '1') {
			if (dados.current.info.notify?.lastUpdated !== dataHoje) {
				const jsonData = {
					dataAtual: new Date().toISOString(),
					tarefas: [],
					lastUpdated: dataHoje
				};
				return jsonData;
			}
		}

		return null;
	}

	useEffect(() => {
		if (is_edit) {
			setShowOverview(true);
			setShowFunctions(false);
		}
	}, [is_edit]);

	const handleSubmit = async (e) => {
		e.preventDefault();

		// dados.current.profile.id = dados.current.id;
		dados.current.info.notify = atualizarNotificacaoDiaria();
		// dados.current.info.entity_type = dados.current.info?.entity[0]?.id || null;
		dados.current.info.birthday = dados.current.info.birthday || null;
		dados.current.info.username = dados.current.info.username || dados.current.info.razaoSocial;
		dados.current.info.tag = dados.current.info.tag || tag;


		const departamentosToSubmit = Array.isArray(dados.current.info.departamento)
			? dados.current.info.departamento.map(departamento => {
				const selectedSoftwareIds = selectedSoftware[departamento.id] || [];

				const softwareArray = Array.isArray(departamento.software)
					? departamento.software
						.filter(software => selectedSoftwareIds.includes(software.id))
						.map(software => ({
							id: software.id,
							nome: software.nome,
						}))
					: [];

				return {
					id: departamento.id,
					name: departamento.name,
					software: softwareArray,
				};
			})
			: [];

		dados.current.info.departamento = departamentosToSubmit;

		const requestMethod = is_edit ? reqPUT : reqPOST;
		const apiRoute = api_crud_route;

		try {
			const response = await requestMethod(apiRoute, dados.current);
			console.log("Response:", response);
			set_new_password('');
			set_confirm_password('');

			files_image.forEach(async (el_image) => {
				if (el_image !== null) {
					if (el_image.files.length > 0) {
						await uploadFilesImage(el_image.files, el_image.order, 'photo', el_image.langid, el_image.lang)
					}
				}
			})
			set_files_image([])
			set_image_base64([])
			// set_photo_base64('')

			files_doc.forEach(async (el_doc) => {
				if (el_doc !== null) {
					await uploadFilesDoc(el_doc.files, el_doc.order, 'cv', el_doc.langid, el_doc.lang)
				}
			})
			set_files_doc([])
			set_files_doc_name([])


			if (is_edit) {
				Swal.fire('', 'Atualizado com sucesso', 'success');
			}
			else {
				props.history.push(endpoints.list);
				// window.location.reload();
			}

		} catch (error) {
			console.error("Submission error:", error);
			const errorMsg = is_edit ? language[lang].edit_error : language[lang].insert_error;
			Swal.fire('', errorMsg, 'info');
		}

	};

	const handleSubmitPassword = async e => {
		e.preventDefault();

		Swal.fire({
			title: language[lang].edit_title,
			text: language[lang].edit_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: color.corPrimaria.rgb,
			cancelButtonColor: color.corVermelha.rgb,
			confirmButtonText: language[lang].edit_confirm,
			cancelButtonText: language[lang].edit_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {
					reqPUT(api_crud_route, dados.current)
						.then(() => { props.history.push(endpoints.list) })
						.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
				}
			})
	}

	function apagar() {

		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: color.corPrimaria.rgb,
			cancelButtonColor: color.corVermelha.rgb,
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {

					reqDELETE(api_crud_route + '/', { id: dados.current.id })
						.then(res => {
							props.history.push(endpoints.list);
						})
						.catch(error => alert(error))

				}
			})
	};

	const load_entity = async (vat, entity) => {
		reqGET(`${api_crud_base}/entities/list/${getTokenInfo().companycode}/${entity}`)
			.then(res => {
				//console.log(res.data)
				// res.data.map((k) => {
				// 	if(k['vat'] === vat) {
				// 		set_dados(dados.current.info.Cliente.id = k['id']);
				// 		set_dados(dados.current.info.Cliente.name = k['name']);
				// 	}
				// });

				let ja_existe = false
				res.data.forEach((k) => {
					//console.log(res.data)
					if (k['vat'] === vat) {
						ja_existe = true
						//set_visible_client_name(true)
						//set_dados(dados.current.info.Cliente.name = k['vat']);
					}
				})

				if (ja_existe === false) {
					//<Link to={{ pathname: '/client_regist', state: { item: vat, operation: 'newFromCredit' } }} />

					//console.log('NãO EXISTE ________________>');
					return

				} else {

					Swal.fire('Já Existe um Registo com este VAT.', '', 'info')

				}
			}
			)
	}

	const handle_change_addresses = (e, addresses_index = 0) => {
		const { name, value } = e.target;
		set_dados(dados.current.addresses[addresses_index][name] = value)
	}

	/* 
	const handle_change_info = (e) => {
		const { name, value } = e.target;
		set_dados(dados.current.info[name] = value);

		if (name === 'razaoSocial') {
			dados.current.info.username = value;
		}
		if (name === 'type') {
			dados.current.profile.name = value;
		}
		if (!is_edit && name === 'vat') {
			if (dados.current.info['vat'].length === 9) {
				load_entity(dados.current.info['vat'], object_type);
			}
		}
	}
	*/

	const handle_change_info = (e) => {
		const { name, value } = e.target;
		let formattedValue = value;

		if (name === 'validade_contribuinte') {
			// Remove all non-digit characters
			const digits = value.replace(/\D/g, '');

			// Format as MM/YY
			if (digits.length <= 2) {
				formattedValue = digits;
			} else {
				formattedValue = digits.slice(0, 2) + '/' + digits.slice(2, 4);
			}
		} else {
			formattedValue = value;
		}

		// Apply the update
		set_dados(dados.current.info[name] = formattedValue);

		if (name === 'razaoSocial') {
			dados.current.info.username = formattedValue;
		}
		if (name === 'type') {
			dados.current.profile.name = formattedValue;
		}
		if (!is_edit && name === 'vat') {
			if (dados.current.info['vat'].length === 9) {
				load_entity(dados.current.info['vat'], object_type);
			}
		}
	};

	const handle_change_login = (e) => {
		const { value } = e.target;

		load_entity('username', value, '')
	}

	const handle_change_info_new_password = (e) => {
		const { value } = e.target;
		set_new_password(value)
	}

	const handle_change_password = (e) => {
		const { value } = e.target;
		if (new_password !== '' && value === new_password) {
			set_dados(dados.current.info.password = passwordHash(new_password))
			set_disabled(false)
		}
		else {
			Swal.fire('Password de confirmação diferente da password inserida.', '', 'info')
			set_disabled(true)
		}
	}

	const handle_change_contacts = (e, index = 0) => {
		const { name, value } = e.target;
		set_dados(dados.current.contacts[index][name] = value)
	}

	const change_entity_attributes = (e) => {
		const { name, value } = e.target;

		if (name === 'entity_category') {
			set_dados(entity_type_filter.current = entity_type.current.filter(el => parseInt(el.parent) === parseInt(value)))
			set_dados(entity_profiles_filter.current = entity_profiles.current.filter(el => parseInt(el.parent) === parseInt(value)))
			set_dados(entity_relation_filter.current = entity_relation.current.filter(el => parseInt(el.parent) === parseInt(value)))
			set_dados(entity_nature_filter.current = [])
			set_dados(dados.current.info.relacao = [])
		}
		else if (name === 'entity_type') {
			set_dados(entity_nature_filter.current = entity_nature.current.filter(el => parseInt(el.parent) === parseInt(value)))

			set_dados(entity_profiles_filter.current = entity_profiles.current.filter(el => parseInt(el.settings.entity_type) === parseInt(value)))
		}
		else if (name === 'entity_nature') {
			set_dados(entity_profiles_filter.current = entity_profiles.current.filter(el => parseInt(el.settings.entity_nature) === parseInt(value)))
		}

		if (dados.current.info.attributes === undefined) {
			dados.current.info.attributes = {}
		}

		set_dados(dados.current.info.attributes[name] = value)

	}

	const handle_entity_relation = (e) => {
		const { value, checked } = e.target;

		if (!dados.current.info.relacao) {
			dados.current.info.relacao = [];
		}

		console.log('value', value)

		const selectedOption = entity_relation.current.find(option => parseInt(option.id) === parseInt(value));
		console.log(selectedOption)
		if (checked && selectedOption) {
			if (!dados.current.info.relacao.some(item => parseInt(item) === parseInt(value))) {
				set_dados(dados.current.info.relacao.push(selectedOption.id))
			}
		}
		else {
			set_dados(dados.current.info.relacao = dados.current.info.relacao.filter(item => parseInt(item) !== parseInt(value)))
		}

		console.log('dados.current.info.relacao', dados.current.info.relacao)
	};


	const open_link = (url) => {
		window.open(url, '_blank');
	}

	const copy_clipboard = (url) => {
		navigator.clipboard.writeText(url)

		Swal.fire({
			icon: '',
			title: '',
			text: 'Copiado',
			showConfirmButton: false,
			timer: 1000
		})
	}

	const handle_change_tree = (tD, order, langid) => {

		treeDataCV[order][langid] = tD

		let aux = []
		if (langid === '1') {
			treeDataCV[order][langid].forEach((el) => {
				dados.current.content[order].media.doc.forEach((el_2) => {
					if (el.id_doc === el_2.id)
						aux.push(el_2)
				})
			});
			set_dados(dados.current.content[order].media.doc = aux)
			setTreeDataCV(treeDataCV)
		}
		else {
			treeDataCV[order][langid].forEach((el) => {
				dados.current.content[order]['language'][langid].media.doc.forEach((el_2) => {
					if (el.id_doc === el_2.id)
						aux.push(el_2)
				})
			});
			set_dados(dados.current.content[order]['language'][langid].media.doc = aux)
			setTreeDataCV(treeDataCV)
		}

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const remove_element_tree_cv = (order, langid, id, doc) => {

		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {

					let treeAux = treeDataCV[order][langid].filter(v => v.id !== id)
					treeDataCV[order][langid] = treeAux
					setTreeDataCV(treeDataCV)

					let aux = []
					if (langid === '1') {
						dados.current.info.cv.forEach((el) => {
							if (el.id !== doc)
								aux.push(el)
						})
						set_dados(dados.current.info.cv = aux)
					}
					else {
						dados.current.info['language'][langid].cv.forEach((el) => {
							if (el.id !== doc)
								aux.push(el)
						})
						set_dados(dados.current.info['language'][langid].cv = aux)
					}

				}
			})

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const edit_element_tree = (e) => {
		const { value, dataset } = e.target;
		const { order, id, /*doc,*/ link } = dataset

		treeDataCV[order].forEach((child) => {
			child.forEach((el) => {
				if (el.id === id) {
					el.title = value

					dados.current.content[order].media.doc.forEach((el_2) => {
						if (el_2.link === link) {
							el_2.name = value
						}
					})
				}
			})
		})
		setTreeDataCV(treeDataCV)
		set_dados(dados.current.content[order],)
	}

	const get_entity_function = (id) => {

		let result = ''
		if (id !== '') {
			let aux = entity_function.current.filter(e => parseInt(e.id) === parseInt(id))
			console.log('aux', aux)
			if (Array.isArray(aux) && aux.length > 0) {
				result = aux[0].label
			}

		}
		return result

	}

	let get_permissions = async (e, sidebar) => {
		let handleSingleCheck = async (e, sidebar) => {
			const name = e;

			let ver_submenu = async (node) => {
				if (node.submenu.length !== 0) {
					// node.submenu.forEach(subitem => {
					for await (let subitem of node.submenu) {

						let name_aux = name.split('_')
						name_aux.pop()
						name_aux = name_aux.join('_')

						if (subitem.path === name || subitem.path.includes(name_aux)) {

							let aux = {}
							if (permissions.current !== null) {
								aux = permissions.current

								if (aux.create !== true) {
									aux.create = subitem.create
								}
								if (aux.edit !== true) {
									aux.edit = subitem.edit
								}
								if (aux.remove !== true) {
									aux.remove = subitem.remove
								}
								if (aux.identificacao !== true) {
									aux.identificacao = subitem.identificacao
								}
								if (aux.naturalidade !== true) {
									aux.naturalidade = subitem.naturalidade
								}
								if (aux.fiscal !== true) {
									aux.fiscal = subitem.fiscal
								}
								if (aux.contrato !== true) {
									aux.contrato = subitem.contrato
								}
								if (aux.funcoes !== true) {
									aux.funcoes = subitem.funcoes
								}
								if (aux.configuracoes !== true) {
									aux.configuracoes = subitem.configuracoes
								}
							}
							else {
								aux = {
									create: subitem.create,
									edit: subitem.edit,
									view: true,
									remove: subitem.remove,

									identificacao: subitem.identificacao,
									naturalidade: subitem.naturalidade,
									fiscal: subitem.fiscal,
									contrato: subitem.contrato,
									funcoes: subitem.funcoes,
									configuracoes: subitem.configuracoes
								}
							}

							set_dados(permissions.current = aux)
						}
						else {
							await ver_submenu(subitem)
						}

					}
				}
			}

			// sidebar.forEach(node => {
			for await (let node of sidebar) {

				let name_aux = name.split('_')
				name_aux.pop()
				name_aux = name_aux.join('_')


				if (node.path === name || node.path.includes(name_aux)) {

					let aux = {}
					if (permissions.current !== null) {
						aux = permissions.current

						if (aux.create !== true) {
							aux.create = node.create
						}
						if (aux.edit !== true) {
							aux.edit = node.edit
						}
						if (aux.remove !== true) {
							aux.remove = node.remove
						}
					}
					else {
						aux = { create: node.create, edit: node.edit, view: true, remove: node.remove }
					}

					// set_permissions({ edit: node.edit, view: true, remove: node.remove })
					set_dados(permissions.current = aux)

					if (Array.isArray(node.submenu) && node.submenu.length > 0) {
						await ver_submenu(node)
					}

				} else
					await ver_submenu(node)
			}
		}

		await handleSingleCheck(e, sidebar)
	}


	return isloading ?
		<Loader />
		:
		isRedirect
			?
			<Redirect to={endpoints.list} replace />
			:
			<main>
				<div className={`dash-cards header`}>
					<h2 className="dash-title">{language[lang].entity}</h2>
					<p>{language[lang].entity} / {dados.current.id !== '' ? language[lang].entity_edit : language[lang].entity_new}</p>
				</div>
				<div className={`dash-cards body`}>
					<div className="container">
						<div className="row">
							<div className="mb-5 mb-xl-10">
								<div className="card">
									<div className="card-header border-0 d-flex justify-content-sm-between p-4 ">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0 text-nowrap">{language[lang].personal_data}</h3>
										</div>
									</div>
									<div id="div-content">
										<form id="form" onSubmit={handleSubmit}>
											<div className="card-body border-top p-4">
												<div className="tab-content">
													<div className="d-flex flex-row flex-wrap justify-content-end gap-2 mb-2">
														{permissions.current != null && permissions.current.identificacao !== null && permissions.current.identificacao && (
															<button
																type="button"
																className={`btn rounded-pill btn-sm py-1 px-4 mb-3 ${showOverView ? 'btn-primary' : 'btn-outline-secondary'}`}
																onClick={() => {
																	setShowOverview(true); //true
																	setShowNat(false);
																	setShowFiscalData(false);
																	setShowFunctions(false);
																	setShowSettings(false);
																	setShowContract(false);
																}}
															>
																{language[lang].identification}
															</button>
														)}
														{permissions.current != null && permissions.current.naturalidade !== null && permissions.current.naturalidade && (
															<button
																type="button"
																className={`btn rounded-pill btn-sm py-1 px-4 mb-3 ${showNat ? 'btn-primary' : 'btn-outline-secondary'}`}
																onClick={() => {
																	setShowOverview(false);
																	setShowNat(true);//true
																	setShowFiscalData(false);
																	setShowFunctions(false);
																	setShowSettings(false);
																	setShowContract(false);
																}}
															>
																{language[lang].naturalidade}
															</button>
														)}
														{permissions.current != null && permissions.current.fiscal !== null && permissions.current.fiscal && (
															<button
																type="button"
																className={`btn rounded-pill btn-sm py-1 px-4 mb-3 ${showFiscalData ? 'btn-primary' : 'btn-outline-secondary'}`}
																onClick={() => {
																	setShowOverview(false);
																	setShowNat(false);
																	setShowFiscalData(true); //true
																	setShowFunctions(false);
																	setShowSettings(false);
																	setShowContract(false);
																}}
															>
																{language[lang].dados_fiscais}
															</button>
														)}
														{permissions.current != null && permissions.current.contrato !== null && permissions.current.contrato && (
															<button
																type="button"
																className={`btn rounded-pill btn-sm py-1 px-4 mb-3 ${showContract ? 'btn-primary' : 'btn-outline-secondary'}`}
																onClick={() => {
																	setShowOverview(false);
																	setShowNat(false);
																	setShowContract(true); //true
																	setShowFunctions(false);
																	setShowSettings(false);
																	setShowFiscalData(false);
																}}
															>
																{language[lang].contrato}
															</button>
														)}
														{permissions.current != null && permissions.current.funcoes !== null && permissions.current.funcoes && (
															<button
																type="button"
																className={`btn rounded-pill btn-sm py-1 px-4 mb-3 ${showFunctions ? 'btn-primary' : 'btn-outline-secondary'}`}
																onClick={() => {
																	setShowOverview(false);
																	setShowFiscalData(false);
																	setShowNat(false);
																	setShowFunctions(true); //true
																	setShowSettings(false);
																	setShowContract(false);
																}}
															>
																{language[lang].functions}
															</button>
														)}
														{permissions.current != null && permissions.current.configuracoes !== null && permissions.current.configuracoes && (
															<button
																type="button"
																className={`btn rounded-pill btn-sm py-1 px-4 mb-3 ${showSettings ? 'btn-primary' : 'btn-outline-secondary'}`}
																onClick={() => {
																	setShowOverview(false);
																	setShowFiscalData(false);
																	setShowNat(false);
																	setShowFunctions(false);
																	setShowSettings(true); //true
																	setShowContract(false);
																}}
															>
																{language[lang].settings}
															</button>
														)}
													</div>

													{showOverView && (
														<div className='p-4'>
															<div className="row mb-4 mb-4">
																<div className="col-md-4">
																	<label className="fs-6 fw-bold mb-2">{language[lang].name}</label>
																	<input type="text" name="name" value={dados.current.info.name} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].name_placeholder} onChange={handle_change_info} required />
																</div>

																<div className="col-md-4 mb-3">
																	<label className="fs-6 fw-bold mb-2">{language[lang].birthday}</label>
																	<input type="date" name="birthday" value={dados.current.info.birthday !== '' ? dados.current.info.birthday : ''}
																		className="form-control mb-3 mb-lg-0 rounded-0"
																		onChange={handle_change_info}
																	/>
																</div>
															</div>

															<div className="row mb-4 mb-4">
																<div className="col-md-4">
																	<label className="fs-6 fw-bold mb-2">{language[lang].tlm}</label>
																	<PhoneInput
																		defaultCountry="PT"
																		className="form-control mb-3 mb-lg-0 rounded-0"
																		placeholder={language[lang].tlm_placeholder}
																		value={dados.current.contacts[0].mobile_phone !== '' ? dados.current.contacts[0].mobile_phone : null}
																		onChange={e => set_dados(dados.current.contacts[0].mobile_phone = e)}
																	/>
																</div>

																{
																	dados.current.info.type !== undefined ?
																		(dados.current.info.type.some(option => option.label === 'Empresarial') || selectedTipoCliente === '2') && (
																			<div className="col-md-4 d-none">
																				<label className="fs-6 fw-bold mb-2">{language[lang].tlf}</label>
																				<PhoneInput
																					defaultCountry="PT"
																					className="form-control mb-3 mb-lg-0 rounded-0"
																					placeholder={language[lang].tlf_placeholder}
																					value={dados.current.contacts[0].phone !== '' ? dados.current.contacts[0].phone : null}
																					onChange={e => set_dados(dados.current.contacts[0].phone = e)}
																				/>
																			</div>
																		)
																		:
																		null
																}

																<div className="col-md-4 mb-3">
																	<label className="fs-6 fw-bold mb-2">{language[lang].email}</label>
																	<input type="email" pattern={pattern_email} name="email" value={dados.current.info.email != undefined && dados.current.info.email != '' ? dados.current.info.email : dados.current.contacts[0].email} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].email_placeholder} onChange={handle_change_contacts} />
																</div>
															</div>


															<div className="row mb-4">
																<div className="col-md-8 mb-3">
																	<label className="fs-6 fw-bold mb-2">{language[lang].morada}</label>
																	<textarea name="address_detail" value={dados.current.addresses[0].address_detail} className="form-control mb-3 mb-lg-0 rounded-0" rows="4" onChange={handle_change_addresses} />
																</div>
															</div>

															<div className="row mb-4">
																<div className="col-md-4">
																	<label className="fs-6 fw-bold mb-2">{language[lang].local}</label>
																	<input type="text" name="localidade" value={dados.current.addresses[0].localidade} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].local_placeholder} onChange={handle_change_addresses} />
																</div>

																<div className="col-md-4 mb-3">
																	<label className="fs-6 fw-bold mb-2">{language[lang].postal_code}</label>
																	<input type="text" name="postal_code" value={dados.current.addresses[0].postal_code} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].postal_code_placeholder} onChange={handle_change_addresses} />
																</div>
															</div>

															<div className="row mb-4">
																<div className="col-md-4">
																	<label className="fs-6 fw-bold mb-2">{language[lang].village}</label>
																	<Select
																		className="div-select"
																		options={villages}
																		name="freguesia"
																		value={dados.current.addresses[0].village === '' ? null : { label: dados.current.addresses[0].village, value: dados.current.addresses[0].village }}
																		placeholder={language[lang].village_placeholder}
																		onChange={change_village}
																	/>
																</div>

																<div className="col-md-4 mb-3">
																	<label className="fs-6 fw-bold mb-2">{language[lang].city}</label>
																	<Select
																		className="div-select"
																		options={cities}
																		name="concelho"
																		value={dados.current.addresses[0].city === '' ? null : { label: dados.current.addresses[0].city, value: dados.current.addresses[0].city }}
																		placeholder={language[lang].city_placeholder}
																		onChange={change_city}
																	/>
																</div>
															</div>

															<div className="row mb-4">
																<div className="col-md-4">
																	<label className="fs-6 fw-bold mb-2">{language[lang].district}</label>
																	<Select
																		className="div-select"
																		options={districts}
																		name="distrito"
																		value={dados.current.addresses[0].region === '' ? null : { label: dados.current.addresses[0].region, value: dados.current.addresses[0].region }}
																		placeholder={language[lang].district_placeholder}
																		onChange={change_district}
																	/>
																</div>

																<div className="col-md-4 mb-3">
																	<label className="fs-6 fw-bold mb-2">{language[lang].country}</label>
																	<Select
																		className="div-select"
																		options={countries}
																		name="pais"
																		value={dados.current.addresses[0].country === '' ? null : { label: dados.current.addresses[0].country, value: dados.current.addresses[0].country }}
																		placeholder={language[lang].country_placeholder}
																		onChange={change_country}
																	/>
																</div>
															</div>

															<div className="row mb-4 mb-4">
																<div className="col-md-4 mb-3">
																	<label className="fs-6 fw-bold mb-2">
																		{language[lang].contribuinte}
																	</label>
																	<input type="text"
																		pattern={pattern_vat}
																		minLength="9"
																		inputMode='numeric'
																		name="numero_contribuinte"
																		value={dados.current.info.numero_contribuinte}
																		className="form-control mb-3 mb-lg-0 rounded-0"
																		placeholder={language[lang].contribuinte_placeholder}
																		onChange={handle_change_info}
																	/>
																</div>

																<div className="col-md-4">
																	<label className="fs-6 fw-bold mb-2">{language[lang].arquivo}</label>
																	<input type="text"
																		name="arquivo"
																		value={dados.current.info.arquivo}
																		className="form-control mb-3 mb-lg-0 rounded-0"
																		placeholder={language[lang].arquivo_placeholder}
																		onChange={handle_change_info} />
																</div>

																<div className="col-md-4">
																	<label className="fs-6 fw-bold mb-2">
																		{language[lang].validade_contribuinte}
																	</label>
																	<input
																		type="text"
																		minLength="5"
																		maxLength="5"
																		inputMode="numeric"
																		name="validade_contribuinte"
																		value={dados.current.info.validade_contribuinte}
																		className="form-control mb-3 mb-lg-0 rounded-0"
																		placeholder={language[lang].validade_contribuinte_placeholder}
																		onChange={handle_change_info}
																	/>
																</div>
															</div>

															<div className="row mb-4">
																<div className="col-md-4 mb-3">
																	<label className="fs-6 fw-bold mb-2">
																		{language[lang].sexo}
																	</label>
																	<select
																		name="sexo"
																		className="form-select form-control mb-4 mb-lg-0 rounded-0"
																		onChange={handle_change_info}
																		value={
																			dados?.current?.info?.sexo !== undefined &&
																				dados?.current?.info?.sexo !== null
																				? dados.current.info.sexo
																				: ''
																		}
																	>
																		<option value="">{language[lang].select}</option>

																		<option value="2">{language[lang].feminino}</option>
																		<option value="1">{language[lang].masculino}</option>
																		<option value="0">{language[lang].outro}</option>

																	</select>
																</div>

																<div className="col-md-4">
																	<label className="fs-6 fw-bold mb-2">
																		{language[lang].estado_civil}
																	</label>
																	<select
																		name="estado_civil"
																		className="form-select form-control mb-4 mb-lg-0 rounded-0"
																		onChange={handle_change_info}
																		value={
																			dados?.current?.info?.estado_civil !== undefined &&
																				dados?.current?.info?.estado_civil !== null
																				? dados.current.info.estado_civil
																				: ''
																		}
																	>
																		<option value="">{language[lang].select}</option>

																		<option value="0">{language[lang].solteiro}</option>
																		<option value="1">{language[lang].casado}</option>
																		<option value="2">{language[lang].divorciado}</option>
																		<option value="3">{language[lang].viuvo}</option>

																	</select>
																</div>
															</div>

															<div className="row mb-4">
																<div className="col-md-4 mb-3">
																	<label className="fs-6 fw-bold mb-2">
																		{language[lang].habilitacao_literaria}
																	</label>
																	<select
																		name="habilitacao_literaria"
																		className="form-select form-control mb-4 mb-lg-0 rounded-0"
																		onChange={handle_change_info}
																		value={
																			dados?.current?.info?.habilitacao_literaria !== undefined &&
																				dados?.current?.info?.habilitacao_literaria !== null
																				? dados.current.info.habilitacao_literaria
																				: ''
																		}
																	>
																		<option value="">{language[lang].select}</option>

																		<option value="0">{language[lang].ensino_basico}</option>
																		<option value="1">{language[lang].ensino_secundario}</option>
																		<option value="2">{language[lang].licenciatura}</option>
																		<option value="3">{language[lang].mestrado}</option>
																		<option value="4">{language[lang].doutoramento}</option>
																		<option value="5">{language[lang].pos_doutoramento}</option>

																	</select>
																</div>

																<div className="col-md-8">
																	<label className="fs-6 fw-bold mb-2">{language[lang].observacoes}</label>
																	<textarea name="observation"
																		value={dados.current.info.observation}
																		className="form-control mb-3 mb-lg-0 rounded-0"
																		rows="4"
																		onChange={handle_change_info} />
																</div>
															</div>
														</div>
													)}

													{showNat && (
														<div className="p-4">
															<div className="row mb-4">
																<div className="col-md-4">
																	<label className="fs-6 fw-bold mb-2">{language[lang].local}</label>
																	<input
																		type="text"
																		name="localidade"
																		value={dados.current.info.localidade}
																		className="form-control mb-3 mb-lg-0 rounded-0"
																		placeholder={language[lang].local_placeholder}
																		onChange={handle_change_info}
																	/>
																</div>
															</div>

															<div className="row mb-4">
																<div className="col-md-4">
																	<label className="fs-6 fw-bold mb-2">{language[lang].village}</label>
																	<input
																		type="text"
																		name="village"
																		value={dados.current.info.village}
																		className="form-control mb-3 mb-lg-0 rounded-0"
																		placeholder={language[lang].village_placeholder}
																		onChange={handle_change_info}
																	/>
																</div>

																<div className="col-md-4 mb-3">
																	<label className="fs-6 fw-bold mb-2">{language[lang].city}</label>
																	<input
																		type="text"
																		name="city"
																		value={dados.current.info.city}
																		className="form-control mb-3 mb-lg-0 rounded-0"
																		placeholder={language[lang].city_placeholder}
																		onChange={handle_change_info}
																	/>
																</div>
															</div>

															<div className="row mb-4">
																<div className="col-md-4">
																	<label className="fs-6 fw-bold mb-2">{language[lang].district}</label>
																	<input
																		type="text"
																		name="region"
																		value={dados.current.info.region}
																		className="form-control mb-3 mb-lg-0 rounded-0"
																		placeholder={language[lang].district_placeholder}
																		onChange={handle_change_info}
																	/>
																</div>

																<div className="col-md-4 mb-3">
																	<label className="fs-6 fw-bold mb-2">{language[lang].country}</label>
																	<input
																		type="text"
																		name="country"
																		value={dados.current.info.country}
																		className="form-control mb-3 mb-lg-0 rounded-0"
																		placeholder={language[lang].country_placeholder}
																		onChange={handle_change_info}
																	/>
																</div>
															</div>
														</div>
													)}

													{showFiscalData && (
														<div className="p-4">
															<div className="row mb-4">
																<div className="col-md-4">
																	<label className="fs-6 fw-bold mb-2">
																		{language[lang].vat}
																	</label>
																	<input type="text"
																		pattern={pattern_vat}
																		minLength="9"
																		inputMode='numeric'
																		name="vat"
																		value={dados.current.info.vat}
																		className="form-control mb-3 mb-lg-0 rounded-0"
																		placeholder={language[lang].vat_placeholder}
																		onChange={handle_change_info}
																	/>
																</div>

																<div className="col-md-4 mb-3">
																	<label className="fs-6 fw-bold mb-2">
																		{language[lang].iban}
																	</label>
																	<input type="text"
																		minLength="25"
																		inputMode='numeric'
																		name="iban"
																		value={dados.current.info.iban}
																		className="form-control mb-3 mb-lg-0 rounded-0"
																		placeholder={language[lang].iban_placeholder}
																		onChange={handle_change_info}
																	/>
																</div>
															</div>

															<div className="row mb-4">
																<div className="col-md-4">
																	<label className="fs-6 fw-bold mb-2">
																		{language[lang].nbss}
																	</label>
																	<input type="text"
																		pattern={pattern_vat}
																		minLength="9"
																		inputMode='numeric'
																		name="nbss"
																		value={dados.current.info.nbss}
																		className="form-control mb-3 mb-lg-0 rounded-0"
																		placeholder={language[lang].nbss_placeholder}
																		onChange={handle_change_info}
																	/>
																</div>

																<div className="col-md-4 mb-3">
																	<label className="fs-6 fw-bold mb-2">
																		{language[lang].ass}
																	</label>
																	<input type="text"
																		pattern={pattern_vat}
																		minLength="9"
																		inputMode='numeric'
																		name="ass"
																		value={dados.current.info.ass}
																		className="form-control mb-3 mb-lg-0 rounded-0"
																		placeholder={language[lang].ass_placeholder}
																		onChange={handle_change_info}
																	/>
																</div>
															</div>
														</div>
													)}

													{showContract && (
														<div className="p-4">
															<div className='row mb-4'>
																<div className="col-md-4 mb-3">
																	<label className="fs-6 fw-bold mb-2">{language[lang].data_admissao}</label>
																	<input type="date" name="data_admissao" value={dados.current.info.data_admissao !== '' ? dados.current.info.data_admissao : ''}
																		className="form-control mb-3 mb-lg-0 rounded-0"
																		onChange={handle_change_info}
																	/>
																</div>

																<div className="col-md-6 mb-3">
																	<label className="fs-6 fw-bold mb-2">
																		{language[lang].tipo_contrato}
																	</label>
																	<select
																		name="tipo_contrato"
																		className="form-select form-control mb-4 mb-lg-0 rounded-0"
																		onChange={handle_change_info}
																		value={
																			dados?.current?.info?.tipo_contrato !== undefined &&
																				dados?.current?.info?.tipo_contrato !== null
																				? dados.current.info.tipo_contrato
																				: ''
																		}
																	>
																		<option value="">{language[lang].select}</option>

																		<option value="0">{language[lang].contrato_sem_termo}</option>
																		<option value="1">{language[lang].contrato_termo_certo}</option>
																		<option value="2">{language[lang].contrato_termo_incerto}</option>
																		<option value="3">{language[lang].contrato_part_time}</option>
																		<option value="4">{language[lang].contrato_estagio}</option>
																		<option value="5">{language[lang].contrato_prestacao_servicos}</option>
																		<option value="6">{language[lang].contrato_intermitente}</option>

																	</select>
																</div>
															</div>

															<div className="row mb-4">
																<div className="col-md-4">
																	<label className="fs-6 fw-bold mb-2">
																		{language[lang].horas_semanais}
																	</label>
																	<input type="text"
																		name="horas_semanais"
																		value={dados.current.info.horas_semanais}
																		className="form-control mb-3 mb-lg-0 rounded-0"
																		placeholder={language[lang].horas_semanais_placeholder}
																		onChange={handle_change_info}
																	/>
																</div>

																<div className="col-md-6 mb-3">
																	<label className="fs-6 fw-bold mb-2">
																		{language[lang].seguro_acidente_trabalho}
																	</label>
																	<input type="text"
																		name="seguro_acidente_trabalho"
																		value={dados.current.info.seguro_acidente_trabalho}
																		className="form-control mb-3 mb-lg-0 rounded-0"
																		placeholder={language[lang].seguro_acidente_trabalho_placeholder}
																		onChange={handle_change_info}
																	/>
																</div>
															</div>
														</div>
													)}

													{showFunctions && (
														<div className="p-4">
															{/*
															<div className="row mb-4">
																{dados.current.info.entity?.some(option => option.label === 'Externa') && selectedColaborador === '2' ? (
																	<>
																		<div className="col-md-3">
																			<label className="fs-6 fw-bold mb-2">{language[lang].entity}</label>
																			<select
																				name="user_type"
																				className="form-select form-control mb-4 mb-lg-0 rounded-0"
																				onChange={handleEntidade}
																				value={selectedColaborador || (dados.current.info.entity?.[0]?.id)}
																				required
																			>
																				<option value="Default">{language[lang].select}</option>
																				{entidadeOptions.map((option) => (
																					<option key={option.id} value={option.id}>
																						{option.label}
																					</option>
																				))}
																			</select>
																		</div>
																		<div className="col-md-3">
																			<label className="fs-6 fw-bold mb-2">{language[lang].entity_type}</label>
																			<select
																				name="user_type"
																				className="form-select form-control mb-4 mb-lg-0 rounded-0"
																				onChange={handleTipoEntidade}
																				value={selectedTipoCliente || (dados.current.info.type?.[0]?.id)}
																				required
																			>
																				<option value="Default">{language[lang].select}</option>
																				{tipoEntidadeOptions.map((option) => (
																					<option key={option.id} value={option.id}>
																						{option.label}
																					</option>
																				))}
																			</select>
																		</div>
																		<div className="col-md-6">
																			<label className="fs-6 fw-bold mb-2">{language[lang].relacao}</label>
																			<div className="row ms-3">
																				{tipoRelacaoOptions.map((option) => (
																					<div key={option.id} className="col-md-4 form-check">
																						<input
																							type="checkbox"
																							className="form-check-input"
																							id={`relacao-${option.id}`}
																							value={option.id}
																							onChange={handleRelacaoChange}
																							checked={dados.current.info.relacao?.some(item => item.id === option.id) || false}
																						/>
																						<label className="form-check-label" htmlFor={`relacao-${option.id}`}>
																							{traduzirTipoRelacao(option.label, lang)}
																						</label>
																					</div>
																				))}
																			</div>
																		</div>
																	</>
																) : (
																	<>
																		<div className="col-md-4">
																			<label className="fs-6 fw-bold mb-2">{language[lang].entity}</label>
																			<select
																				name="user_type"
																				className="form-select form-control mb-4 mb-lg-0 rounded-0"
																				onChange={handleEntidade}
																				value={selectedColaborador || (dados.current.info.entity?.[0]?.id)}
																				required
																			>
																				<option value="Default">{language[lang].select}</option>
																				{entidadeOptions.map((option) => (
																					<option key={option.id} value={option.id}>
																						{traduzEntidade(option.label, lang)}
																					</option>
																				))}
																			</select>
																		</div>
																		<div className="col-md-4">
																			<label className="fs-6 fw-bold mb-2">{language[lang].entity_type}</label>
																			<select
																				name="user_type"
																				className="form-select form-control mb-4 mb-lg-0 rounded-0"
																				onChange={handleTipoEntidade}
																				value={selectedTipoCliente || (dados.current.info.type?.[0]?.id)}
																				required
																			>
																				<option value="Default">{language[lang].select}</option>
																				{tipoEntidadeOptions.map((option) => (
																					<option key={option.id} value={option.id}>
																						{traduzTipoEntidade(option.label, lang)}
																					</option>
																				))}
																			</select>
																		</div>
																	</>
																)}
															</div>
															*/}

															<div className="row mb-4">
																<div className="col-md-4 d-none">
																	<label className="fs-6 fw-bold mb-2">{language[lang].entity}</label>
																	<select
																		name="entity_category"
																		className="form-select form-control mb-4 mb-lg-0 rounded-0"
																		onChange={change_entity_attributes}
																		value={dados?.current?.info?.attributes?.entity_category !== undefined && dados?.current?.info?.attributes?.entity_category !== null ? dados.current.info.attributes.entity_category : ''}
																		required
																	>
																		<option value="">{language[lang].select}</option>
																		{
																			entity_category.current !== undefined && entity_category.current !== null ?
																				entity_category.current.map((option, key) => (
																					<option key={key} value={option.id}>
																						{option.label}
																					</option>
																				))
																				:
																				null
																		}
																	</select>
																</div>

																{
																	dados?.current?.info?.attributes?.entity_category !== undefined && dados?.current?.info?.attributes?.entity_category !== '' ?
																		<div className="col-md-4 mb-3">
																			<label className="fs-6 fw-bold mb-2">{language[lang].entity_type}</label>
																			<select
																				name="entity_type"
																				className="form-select form-control mb-4 mb-lg-0 rounded-0"
																				onChange={change_entity_attributes}
																				value={dados?.current?.info?.attributes?.entity_type !== undefined && dados?.current?.info?.attributes?.entity_type !== null ? dados.current.info.attributes.entity_type : ''}
																				required
																			>
																				<option value="">{language[lang].select}</option>
																				{
																					entity_type_filter.current !== undefined && entity_type_filter.current !== null ?
																						entity_type_filter.current.map((option, key) => (
																							<option key={key} value={option.id}>
																								{option.label}
																							</option>
																						))
																						:
																						null
																				}
																			</select>
																		</div>
																		:
																		null
																}

																{
																	dados?.current?.info?.attributes?.entity_type !== undefined && dados?.current?.info?.attributes?.entity_type !== '' ?
																		<div className="col-md-4 mb-3">
																			<label className="fs-6 fw-bold mb-2">{language[lang].entity_nature}</label>
																			<select
																				name="entity_nature"
																				className="form-select form-control mb-4 mb-lg-0 rounded-0"
																				onChange={change_entity_attributes}
																				value={dados?.current?.info?.attributes?.entity_nature !== undefined && dados?.current?.info?.attributes?.entity_nature !== null ? dados.current.info.attributes.entity_nature : ''}
																				required
																			>
																				<option value="">{language[lang].select}</option>
																				{
																					entity_nature_filter.current !== undefined && entity_nature_filter.current !== null ?
																						entity_nature_filter.current.map((option, key) => (
																							<option key={key} value={option.id}>
																								{option.label}
																							</option>
																						))
																						:
																						null
																				}
																			</select>
																		</div>
																		:
																		null
																}
															</div>

															{
																dados?.current?.info?.attributes?.entity_category !== undefined && dados?.current?.info?.attributes?.entity_category !== '' && entity_relation_filter.current !== undefined && entity_relation_filter.current !== null && entity_relation_filter.current.length > 0 ?
																	<div className="row mb-4">
																		<div className="col-6 col-md-3">
																			<label className="fs-6 fw-bold mb-2">{language[lang].relacao}</label>
																			<div className="row ms-3">
																				{
																					entity_relation_filter.current !== undefined && entity_relation_filter.current !== null ?
																						entity_relation_filter.current.map((option, key) => (
																							<div key={key} className="col-md-4 form-check">
																								<input
																									type="checkbox"
																									className="form-check-input"
																									id={`relacao-${option.id}`}
																									value={option.id}
																									onChange={handle_entity_relation}
																									checked={dados.current.info.relacao?.some(item => parseInt(item) === parseInt(option.id)) || false}
																								/>
																								<label className="form-check-label" htmlFor={`relacao-${option.id}`}>
																									{option.label}
																								</label>
																							</div>
																						))
																						:
																						null
																				}
																			</div>
																		</div>
																	</div>
																	:
																	null
															}

															<div className="row mb-4">
																{
																	dados.current.info.attributes !== undefined && dados.current.info.attributes.entity_category !== undefined && parseInt(dados.current.info.attributes.entity_category) === parseInt('1') ?
																		<div className="col-md-4 mb-3">
																			<label className="fs-6 fw-bold mb-2">{language[lang].profile}</label>
																			<select
																				name="profile"
																				className="form-select form-control mb-4 mb-lg-0 rounded-0"
																				onChange={handleUserTypeChange}
																				value={dados.current.profile.id}
																			>
																				<option value="">{language[lang].select}</option>
																				{
																					app_profiles.current !== undefined && app_profiles.current !== null ?
																						app_profiles.current.map((option, key) => (
																							<option key={key} value={option.id}>
																								{option.name}
																							</option>
																						))
																						:
																						null
																				}
																			</select>
																		</div>
																		:
																		null
																}

																{
																	dados.current.info.attributes !== undefined && dados.current.info.attributes.entity_category !== undefined && parseInt(dados.current.info.attributes.entity_category) === parseInt('1') ?
																		<div className="col-md-4 mb-3">
																			<label className="fs-6 fw-bold mb-2">{language[lang].entity_type}</label>
																			<select
																				name="entity_profile"
																				className="form-select form-control mb-4 mb-lg-0 rounded-0"
																				onChange={change_entity_attributes}
																				value={dados?.current?.info?.attributes?.entity_profile !== undefined && dados?.current?.info?.attributes?.entity_profile !== null ? dados.current.info.attributes.entity_profile : ''}
																			>
																				<option value="">{language[lang].select}</option>
																				{
																					entity_profiles_filter.current !== undefined && entity_profiles_filter.current !== null ?
																						entity_profiles_filter.current.map((option, key) => (
																							<option key={key} value={option.id}>
																								{option.name}
																							</option>
																						))
																						:
																						null
																				}
																			</select>
																		</div>
																		:
																		null
																}

																{
																	dados.current.info.attributes !== undefined && dados.current.info.attributes.entity_category !== undefined && parseInt(dados.current.info.attributes.entity_category) === parseInt('1') ?
																		<div className="col-md-4 mb-3">
																			<label className="fs-6 fw-bold mb-2">{language[lang].entity_function}</label>
																			<select
																				name="entity_function"
																				className="form-select form-control mb-4 mb-lg-0 rounded-0"
																				onChange={handleUserTypeEntityFunctionsChange}
																				value={''}
																			>
																				<option value="">{language[lang].select}</option>
																				{
																					entity_function_filter.current !== undefined && entity_function_filter.current !== null ?
																						entity_function_filter.current.map((option, key) => (
																							<option key={key} value={option.id}>
																								{option.label}
																							</option>
																						))
																						:
																						null
																				}
																			</select>

																			<div>
																				{
																					dados.current.info?.attributes.entity_function !== undefined && Array.isArray(dados.current.info?.attributes.entity_function) ?
																						dados.current.info?.attributes.entity_function.map((el_ep, k_ep) => {
																							return (
																								<span key={k_ep} className='badge bg-secondary mt-2 me-2 px-3 py-2 rounded-0' onClick={() => handleUserTypeEntityRemove(el_ep)}>
																									{get_entity_function(el_ep)} <i className="bi bi-x-lg ms-2 text-white"></i>
																								</span>
																							)
																						})
																						:
																						null
																				}
																			</div>
																		</div>
																		:
																		null
																}

															</div>
														</div>
													)}

													{showFunctions && (
														<div className="row mb-4">
															{/* 
															<div className="card-header border-0" aria-expanded="true" aria-controls="div_departamento_table">
																<div className="card-title m-0 d-flex justify-content-between align-items-center">
																	<h3 className="fw-bolder m-0">{language[lang].departament}</h3>
																	<div className="d-flex">
																		<button
																			type="button"
																			onClick={() => setModalDepartamento(true)}
																			className="btn btn-default btn-sm me-2">
																			{language[lang].adicionar_departamento}
																		</button>
																		<button
																			type="button"
																			onClick={() => setModalResponsavel(true)}
																			className="btn btn-default btn-sm">
																			{language[lang].adicionar_entidade}
																		</button>
																	</div>
																</div>
															</div>

															<div className="container">
																<table className="table table-bordered" style={tableStyle}>
																	<thead>
																		<tr>
																			<th style={departamentoHeaderCellStyle}>{language[lang].departamento}</th>
																			<th style={headerCellStyle}>{language[lang].responsaveis}</th>
																			<th style={headerCellStyle}>{language[lang].email}</th>
																			<th style={headerCellStyle}>{language[lang].tlm}</th>
																			<th style={headerCellStyle}>{language[lang].ações}</th>
																		</tr>
																	</thead>
																	<tbody>
																		{dados.current.contacts?.[0]?.departamentos?.map((departamento, index) => (
																			<tr key={index} style={rowStyle}>
																				<td style={departmentCellStyle} onClick={() => mostrarDetalhes(departamento.id)}>
																					{departamento.name}
																				</td>
																				<td style={cellStyle} onClick={() => mostrarDetalhes(departamento.id)}>
																					<ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
																						{departamento.responsaveis?.map((responsavel) => (
																							<li key={responsavel.id}>
																								<span>{responsavel.nome}</span>
																							</li>
																						))}
																					</ul>
																				</td>
																				<td style={cellStyle} onClick={() => mostrarDetalhes(departamento.id)}>
																					<ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
																						{departamento.responsaveis?.map((responsavel) => (
																							<li key={responsavel.id}>
																								<span>{responsavel.email}</span>
																							</li>
																						))}
																					</ul>
																				</td>
																				<td style={cellStyle} onClick={() => mostrarDetalhes(departamento.id)}>
																					<ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
																						{departamento.responsaveis?.map((responsavel) => (
																							<li key={responsavel.id}>
																								<span>{responsavel.telefone}</span>
																							</li>
																						))}
																					</ul>
																				</td>
																				<td style={actionCellStyle}>
																					<button
																						onClick={(e) => { e.stopPropagation(); handleRemoveDepartamento(departamento.id); }}
																						style={{ background: 'none', border: 'none', cursor: 'pointer', marginRight: '8px' }}
																					>
																						🗑️
																					</button>
																				</td>
																			</tr>
																		))}
																	</tbody>
																	<tfoot>
																		<tr style={lastRowStyle}>
																			<td colSpan="5" style={{ ...cellStyle, textAlign: 'right' }}>
																				{language[lang].total_departament}: {dados.current.contacts?.[0]?.departamentos?.length || 0}
																			</td>
																		</tr>
																	</tfoot>
																</table>
															</div>

															<div className="card-body">
																<div className="card-body p-4">
																	<div className='row mb-6'>
																		{modalDepartamento && (
																			<div className="modal show" style={{ display: 'block', marginTop: '5%', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
																				<div className="modal-dialog modal-lg">
																					<div className="modal-content">
																						<div className="modal-header">
																							<h5 className="modal-title">📝 {language[lang].adicionar_departamento}</h5>
																							<button type="button" className="close" onClick={() => setModalDepartamento(false)}>
																								&times;
																							</button>
																						</div>
																						<div className="modal-body">
																							<div className="form-group">
																								<label className="fs-5 mb-2">
																									{language[lang].name_departamento}
																									<input
																										type="text"
																										value={departamentoInput}
																										className="form-control"
																										placeholder="Nome do departamento"
																										onChange={(e) => setDepartamentoInput(e.target.value)}
																									/>
																								</label>
																							</div>
																						</div>
																						<div className="modal-footer">
																							<button type="button" className="btn btn-default" onClick={() => setModalDepartamento(false)}>
																								{language[lang].close}
																							</button>
																							<button type="button" className="btn btn-default" onClick={handleAddDepartamento}>
																								{language[lang].add}
																							</button>
																						</div>
																					</div>
																				</div>
																			</div>
																		)}
																		{modalResponsavel && (
																			<div className="modal show" style={{ display: 'block', marginTop: '5%', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
																				<div className="modal-dialog modal-lg">
																					<div className="modal-content">
																						<div className="modal-header">
																							<h5 className="modal-title">📝 {language[lang].adicionar_entidade}</h5>
																							<button type="button" className="close" onClick={() => setModalResponsavel(false)}>
																								&times;
																							</button>
																						</div>
																						<div className="modal-body">
																							<div className="row mb-4">
																								<div className="col-md-6">
																									<div className="form-group">
																										{dados.current.contacts[0].departamentos.length > 0 ? (
																											<label className="fs-5 mb-2">
																												{language[lang].departamento}
																												<select
																													value={selectedDepartamentoId}
																													onChange={(e) => setSelectedDepartamentoId(e.target.value)}
																													className="form-select form-control"
																												>
																													<option value="">{language[lang].selec_departamento}</option>
																													{dados.current.contacts[0].departamentos.map((departamento) => (
																														<option key={departamento.id} value={departamento.id}>
																															{departamento.name}
																														</option>
																													))}
																												</select>
																											</label>
																										) : (
																											<p className="fs-5 mb-2">{language[lang].no_departamento}</p>
																										)}
																									</div>
																									<div className="form-group">
																										<label className="fs-5 mb-2">
																											{language[lang].nome_responsavel}
																											<input
																												type="text"
																												value={responsavelInputNome}
																												onChange={(e) => setResponsavelInputNome(e.target.value)}
																												className="form-control"
																												placeholder="Nome do Responsável"
																											/>
																										</label>
																									</div>
																								</div>
																								<div className="col-md-6">
																									<div className="form-group">
																										<label className="fs-5 mb-2">
																											{language[lang].email}
																											<input
																												type="email"
																												value={responsavelInputEmail}
																												onChange={(e) => setResponsavelInputEmail(e.target.value)}
																												className="form-control"
																												placeholder="Email"
																											/>
																										</label>
																									</div>
																									<div className="form-group">
																										<label className="fs-5 mb-2">
																											{language[lang].tlf}
																											<input
																												type="tel"
																												value={responsavelInputTel}
																												onChange={(e) => setResponsavelInputTel(e.target.value)}
																												className="form-control"
																												placeholder="Telefone"
																											/>
																										</label>
																									</div>
																								</div>
																							</div>
																						</div>
																						<div className="modal-footer">
																							<button type="button" className="btn btn-default" onClick={() => setModalResponsavel(false)}>
																								{language[lang].close}
																							</button>
																							<button type="button" className="btn btn-default" onClick={handleAddResponsavel}>
																								{language[lang].add}
																							</button>
																						</div>
																					</div>
																				</div>
																			</div>
																		)}
																		{modalDetalhes && selectedDepartamento && (
																			<div
																				className="modal show d-flex justify-content-center align-items-center"
																				style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
																			>
																				<div className="modal-dialog" style={{ maxWidth: '700px', width: '90%' }}>
																					<div className="modal-content">
																						<div className="modal-header">
																							<h5 className="modal-title">✏️ {language[lang].detalhes_departamento}</h5>
																							<button
																								type="button"
																								className="close"
																								onClick={handleCloseModal}
																							>
																								&times;
																							</button>
																						</div>
																						<div className="modal-body">
																							<div className="mb-3">
																								<label className="w-100">{language[lang].name_departamento}</label>
																								<input
																									type="text"
																									value={selectedDepartamento.name}
																									onChange={(e) =>
																										setSelectedDepartamento({ ...selectedDepartamento, name: e.target.value })
																									}
																									className="form-control mt-2"
																								/>
																							</div>
																							<div className="mb-4" style={{ marginTop: '5%' }}>
																								<label>{language[lang].responsaveis}</label>
																								<div className="mt-2"></div>
																								<ul className="list-unstyled">
																									{selectedDepartamento.responsaveis.map((responsavel, index) => (
																										<li key={responsavel.id} className="mb-3">
																											<div className="d-flex align-items-center">
																												<label className="mr-2">{language[lang].name}:</label>
																												<input
																													type="text"
																													value={responsavel.nome}
																													onChange={(e) => {
																														const updatedResponsaveis = [...selectedDepartamento.responsaveis];
																														updatedResponsaveis[index].nome = e.target.value;
																														setSelectedDepartamento({ ...selectedDepartamento, responsaveis: updatedResponsaveis });
																													}}
																													className="form-control mr-3"
																													placeholder="Nome"
																													style={{ flex: 1, marginRight: '15px' }}
																												/>
																												<label className="mr-2">{language[lang].email}:</label>
																												<input
																													type="email"
																													value={responsavel.email}
																													onChange={(e) => {
																														const updatedResponsaveis = [...selectedDepartamento.responsaveis];
																														updatedResponsaveis[index].email = e.target.value;
																														setSelectedDepartamento({ ...selectedDepartamento, responsaveis: updatedResponsaveis });
																													}}
																													className="form-control mr-3"
																													placeholder="Email"
																													style={{ flex: 1, marginRight: '15px' }}
																												/>
																												<label className="mr-2">{language[lang].tlf}:</label>
																												<input
																													type="tel"
																													value={responsavel.telefone}
																													onChange={(e) => {
																														const updatedResponsaveis = [...selectedDepartamento.responsaveis];
																														updatedResponsaveis[index].telefone = e.target.value;
																														setSelectedDepartamento({ ...selectedDepartamento, responsaveis: updatedResponsaveis });
																													}}
																													className="form-control mr-3"
																													placeholder="Telefone"
																													style={{ flex: 1 }}
																												/>
																												<button
																													type="button"
																													onClick={() => {
																														const updatedResponsaveis = selectedDepartamento.responsaveis.filter((_, i) => i !== index);
																														setSelectedDepartamento({ ...selectedDepartamento, responsaveis: updatedResponsaveis });
																													}}
																												>
																													✖️
																												</button>
																											</div>
																										</li>
																									))}
																								</ul>
																							</div>
																						</div>
																						<div className="modal-footer">
																							<button
																								type="button"
																								className="btn btn-default"
																								onClick={handleCloseModal}
																							>
																								{language[lang].cancel}
																							</button>
																							<button
																								type="button"
																								className="btn btn-default"
																								onClick={handleSaveChanges}
																							>
																								{language[lang].save_entidade}
																							</button>
																						</div>
																					</div>
																				</div>
																			</div>
																		)}
																	</div>
																</div>
															</div>
															*/}
															<div className="card-body p-4">
																<div className="row mb-6">
																	<label className="fs-6 fw-bold mb-2">{language[lang].dep_emp}</label>
																	<div className="col-md-6">
																		<div
																			className="form-control mb-3 mb-lg-0 rounded-0"
																			style={{ height: 'auto', width: '1250px', borderWidth: '1px' }}
																		>
																			{departamentos.length > 0 ? (
																				departamentos.map((departamento) => (
																					<div key={departamento.id} className="form-check">
																						<input
																							type="checkbox"
																							className="form-check-input"
																							id={`departamento-${departamento.id}`}
																							checked={checkDepartmento(departamento.id)}
																							onChange={() => escolheDepartamentos(departamento.id)}
																						/>
																						<label className="form-check-label" htmlFor={`departamento-${departamento.id}`}>
																							{departamento.name}
																						</label>
																						{departamento.software && departamento.software.length > 0 && (
																							<div className="nested-checkboxes ms-4">
																								{departamento.software
																									.filter(softwareType => softwareType.state === true)
																									.map((softwareType) => (
																										<div key={softwareType.id} className="form-check d-flex justify-content-between align-items-center">
																											<div>
																												<input
																													type="checkbox"
																													className="form-check-input"
																													id={`software-${departamento.id}-${softwareType.id}`}
																													checked={checkSoftware(departamento.id, softwareType.id)}
																													onChange={() => escolheSoftware(departamento.id, softwareType.id)}
																													disabled={!checkDepartmento(departamento.id)}
																												/>
																												<label className="form-check-label ms-2" htmlFor={`software-${departamento.id}-${softwareType.id}`}>
																													{`${language[lang].certificacao} ${softwareType.nome}`}
																												</label>
																											</div>
																											<button
																												type="button"
																												className="btn btn-sm btn-danger d-none" //d-none quando não for necessário eliminar um software
																												onClick={() => removeSoftware(departamento.id, softwareType.id)}
																											>
																												X
																											</button>
																										</div>
																									))}
																							</div>
																						)}
																					</div>
																				))
																			) : (
																				<div>{language[lang].carregar}</div>
																			)}
																		</div>
																	</div>
																</div>
															</div>
														</div>
													)}
												</div>
											</div>
										</form>
									</div>
								</div>

								{showSettings && (
									<div className="row mb-5 bg-white shadow-sm rounded p-4">
										<div className="col-md-6 mb-5">
											<div className="mb-3">
												<label className="fs-6 fw-bold mb-2">
													{language[lang].username}
												</label>
												<input
													type="text"
													name="username"
													value={dados.current.info.username}
													pattern="[a-zA-Z\u00C0-\u00FF.]+"
													className="form-control"
													placeholder={language[lang].username_placeholder}
													onChange={handle_change_info}
													onBlur={handle_change_login}
													autoComplete="off"
												/>
											</div>

											<div className="mb-3">
												<label className="fs-6 fw-bold mb-2">
													{language[lang].password}
												</label>
												<input
													type="password"
													name="password"
													value={new_password}
													min="9"
													title="A password deve de conter pelo menos 9 digitos alfa-númericos"
													className="form-control"
													placeholder={is_edit ? "*************" : language[lang].password_placeholder}
													onChange={handle_change_info_new_password}
													autoComplete="off"
												/>
											</div>

											<div>
												<label className="fs-6 fw-bold mb-2">
													{language[lang].password_confirmation}
												</label>
												<input
													type="password"
													name="password_conf"
													defaultValue={confirm_password}
													min="9"
													className="form-control"
													placeholder={is_edit ? "*************" : language[lang].password_placeholder}
													onBlur={handle_change_password}
													autoComplete="off"
												/>
											</div>
										</div>

										{/* Image Upload */}
										<div className="col-md-6 p-4 bg-white shadow-sm rounded">
											<div className="mt-4">
												<ul className="list-unstyled d-flex flex-wrap gap-3 mt-3 justify-content-center">
													{
														photo_base64 !== '' ?
															<img
																src={photo_base64}
																className="img-fluid rounded"
																alt="Uploaded"
																style={{ width: "120px", height: "120px", objectFit: "cover" }}
															/>
															:
															dados?.current?.info?.foto?.length > 0 ? (
																dados.current.info.foto.map((file, index) => {
																	const imageURL = file.link || URL.createObjectURL(file);
																	return (
																		<li key={index} className="d-flex flex-column align-items-center">
																			<img
																				src={imageURL}
																				className="img-fluid rounded"
																				alt="Uploaded"
																				style={{ width: "120px", height: "120px", objectFit: "cover" }}
																			/>
																			<small className="mt-2 text-muted d-none">{file.name || 'Imagem'}</small>
																		</li>
																	);
																})
															) : (
																<li className="text-muted">{language[lang].noPhoto}</li>
															)}
												</ul>

												<div className="d-flex justify-content-center mt-4 gap-2">
													<input
														type="file"
														accept="image/*"
														onChange={onChangeHandlerFilesImage}
														data-order={1}
														data-langid={lang_id}
														data-lang={lang}
														data-type={'image'}
														className="dropzone-select btn btn-sm btn-primary me-2 d-none"
														id="photo-upload"
													/>

													<label htmlFor="photo-upload" className="btn btn-outline-primary btn-sm">
														{language[lang].photo}
													</label>

													{dados?.current?.info?.foto?.length > 0 && (
														<button
															type="button"
															onClick={handleFileRemove}
															style={{
																marginLeft: "5px",
																backgroundColor: color.corVermelha.rgb,
																color: "#FFF",
																border: "none",
																borderRadius: "5px",
																cursor: "pointer",
																padding: "3px 10px",
															}}
														>
															X
														</button>
													)}
												</div>
											</div>
										</div>

										<div className="row mb-5">
											<div className="col-md-6">
												<div className="div-doc">
													<label className="col-form-label fw-bold fs-6">{language[lang].carregar_cv}</label>

													<div className="dropzone-panel mb-lg-0 mb-2">
														<div className="div-form-input col-12 custom-file">
															<label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2 dz-clickable" htmlFor={"input-files-pdf-" + '0' + '-' + '1'}>{language[lang].doc_choose}</label>
															<input
																id={"input-files-pdf-" + '0' + '-' + '1'}
																type="file"
																accept="application/pdf"
																data-order={'0'}
																data-langid={'1'}
																data-lang={lang}
																data-type={'doc'}
																className="dropzone-select btn btn-sm btn-primary me-2 d-none"
																onChange={onChangeHandlerFilesPDF}
																multiple
															/>
														</div>
													</div>

													<div className="row">
														{console.log('treeDataCV', treeDataCV)}
														{
															treeDataCV !== undefined && treeDataCV[0] !== undefined && treeDataCV[0][1] !== undefined ?
																<SortableTree
																	isVirtualized={false}
																	treeData={treeDataCV[0][1]}
																	maxDepth={1}
																	canDrag={false}
																	//onChange={() => console.log('onChange')}
																	onChange={treeDataCV => handle_change_tree(treeDataCV, '0', '1')}
																	getNodeKey={({ node }) => node.id}
																	generateNodeProps={extendedNode => ({
																		title: (
																			<input type="text" className="form-control form-control-sm rounded-0" defaultValue={extendedNode.node.title} data-order={0} data-id={extendedNode.node.id} data-doc={extendedNode.node.id_doc} data-link={extendedNode.node.link} onBlur={edit_element_tree} />
																		),
																		buttons: [
																			<button type="button" onClick={() => open_link(extendedNode.node.link)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="link"><i className="bi bi-link"></i></button>,
																			<button type="button" onClick={() => copy_clipboard(extendedNode.node.link)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="clipboard"><i className="bi bi-clipboard"></i></button>,
																			<button type="button" onClick={() => console.log('eye')} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm d-none" title="eye"><i className={"bi bi-eye" + (extendedNode.node.visible === true ? '' : '-slash')}></i></button>,
																			<button type="button" onClick={() => remove_element_tree_cv('0', '1', extendedNode.node.id, extendedNode.node.id_doc)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="remove"><i className="bi bi-trash-fill"></i></button>,
																		],
																	})}
																/>
																:
																null
														}
													</div>
												</div>
											</div>
										</div>
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
				<div className={'dash-cards footer'}>
					<nav className="navbar bottom-navbar navbar-light">
						<div className="navbar-footer">
							<ul className="navbar-nav float-left"></ul>
							<ul className="navbar-nav float-right">
								<li className={(getTokenInfo().profile === 'Cliente') ? 'd-none' : "nav-item"}>
									<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}  >
										<i className="bi bi-chevron-left me-2"></i>
										<span>{language[lang].back}</span>
									</Link>
								</li>
								<li className={"nav-item " + show_delete_button}>
									<button type="button" onClick={() => apagar(dados.current.id)} className="nav-link btn-delete">
										<i className="bi bi-trash3 me-2"></i>
										<span>{language[lang].delete}</span>
									</button>
								</li>
								<li className="nav-item">
									<button type="submit" form="form" className="nav-link">
										<i className="bi bi-floppy me-2"></i>
										<span>{language[lang].save}</span>
									</button>
								</li>
							</ul>
						</div>
					</nav>
				</div>
			</main >
}
